"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.toSizeableHeading2Slice = void 0;
var utils_1 = require("@lglp/utils");
var types_1 = require("../../types");
var fields_1 = require("../fields");
var slice_1 = require("./slice");
var HEADING_SIZE_PRISMIC_TO_LGLP = {
    Grand: types_1.Heading2Size.large,
    Petit: types_1.Heading2Size.small
};
var toSizeableHeading2Slice = function (data, logger) {
    var _a, _b;
    var text = logger.required(fields_1.toRichText((_a = data === null || data === void 0 ? void 0 : data.primary) === null || _a === void 0 ? void 0 : _a.text, logger));
    if (text) {
        return utils_1.compact(__assign(__assign({}, slice_1.toSlice(data, types_1.SliceType.SizeableHeading2)), { text: text, size: logger.toConstValue((_b = data === null || data === void 0 ? void 0 : data.primary) === null || _b === void 0 ? void 0 : _b.size, HEADING_SIZE_PRISMIC_TO_LGLP) }));
    }
    return undefined;
};
exports.toSizeableHeading2Slice = toSizeableHeading2Slice;
//# sourceMappingURL=sizeable-heading2-slice.js.map